<template>
  <div>
    <Button
      v-if="infoCtrl && isDetailLoad" class="add-btn"
      type="primary" style="  margin-left:220px ; float: left; margin-top: -64px;"
      @click="openEdit"
    >修改</Button>

    <Row v-if="!infoCtrl&&isDetailLoad" class="case-form">
      <Form
        ref="formData" :model="formData"
        :rules="ruleValidate" :label-width="100"
      >
        <FormItem label="受理法院" prop="court">
          <span v-if="formData.court">{{ formData.court }}</span>
          <mySelect
            v-else
            ref="courtSelect"
            v-autoFill="autoFill.court"
            :path="'/report/courts'"
            :placeholder="'请选择管辖法院'"
            :placeholder-input="'请输入管辖法院'"
            :default-obj="defaultCourt"
            :key-name="'name'"
            :is-load="false"
            @getValue="getCourtId"
          />
        </FormItem>
        <FormItem label="案号" prop="caseNumber">
          <Input v-model="formData.caseNumber" placeholder="请输入案号" />
        </FormItem>
        <Row class="detail-btn-box">
          <Button
            type="primary" style="margin-right:10px;"
            :disabled="isSubmit" @click="submitNew"
          >保存</Button>
          <Button v-if="defaultData" @click="infoCtrl = true">取消</Button>
        </Row>
      </Form>
    </Row>
    <Row v-if="infoCtrl&&isDetailLoad" class="detail-content">
      <Row>
        <Col span="5" class="left-label">受理法院：</Col>
        <Col span="16" class="right-content">{{ defaultData.court }}</Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">案号：</Col>
        <Col span="16" class="right-content">{{ defaultData.caseNumber }}</Col>
      </Row>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'Acceptance',
  props: ['caseId', 'processId', 'caseState'],
  data() {
    return {
      isDetailLoad: false,
      infoCtrl: true,
      defaultData: '',
      isSubmit: false,
      formData: {
        caseNumber: '', // 案号
        courtId: '',
        court: ''
      },
      ruleValidate: {
        court: [{ required: true, message: '递交法院不能为空', trigger: 'change' }],
        caseNumber: [{ required: true, message: '案号不可为空', trigger: 'blur' }]
      },
      autoFill: {
        court: false
      },
      defaultCourt: {}
    }
  },
  beforeMount() {
    this.getDetail()
  },
  methods: {
    // 获取默认展示数据
    getDetail() {
      const url = '/business/case/enforces?processId=' + this.processId
      this.$get(url).then(res => {
        if (res.code === 0 && res.data) {
          if (res.data[0]) {
            this.defaultData = res.data[0]
            this.infoCtrl = !!this.defaultData.caseNumber
            this.giveDefaultData()
            this.isDetailLoad = true
          } else {
            this.defaultData = ''
            this.infoCtrl = false
            this.isDetailLoad = true
          }
        }
      })
    },
    // 赋默认值
    giveDefaultData() {
      this.formData.caseNumber = this.defaultData.caseNumber || ''
      this.formData.court = this.defaultData.court || ''
      this.formData.courtId = this.defaultData.courtId || ''
      this.isDetailLoad = true
      if (this.defaultData.court) {
        this.defaultCourt = {
          name: this.defaultData.court,
          id: this.defaultData.courtId
        }
      }
    },
    getCourtId(data) {
      this.formData.court = data.name
      this.formData.courtId = data.id
      if (this.autoFill.court) {
        this.autoFill.court = false
      }
    },
    openEdit() {
      this.infoCtrl = false
    },
    submitNew() {
      const url = this.defaultData.id ? `/business/case/enforce/accept/${this.defaultData.id}` : '/business/case/enforce'
      /* let url = `/business/case/enforce/accept` */
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId
      }
      Object.assign(ajaxData, this.formData)
      // 修改
      /* if (this.defaultData.caseNumber) { */

      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.isSubmit = true
          const result = this.defaultData.id ? this.$patch(url, ajaxData) : this.$post(url, ajaxData)
          result.then(res => {
            if (res.code === 0) {
              this.getDetail()
              this.$Message.success('操作成功')
              this.$emit('reloadProcess')
            } else {
              this.$Message.error(res.message)
            }
          })
          /* this.$patch(url, ajaxData).then(res => {
            this.isSubmit = false
            if (res.code === 0) {
              this.getDetail()
              this.$Message.success('操作成功')
              this.$emit('reloadProcess')
            } else {
              this.$Message.error(res.message)
            }
          }) */
        }
      })
      /* } else { // 添加
        Object.assign(ajaxData, this.formData)
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code === 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      } */
    }
  }

}
</script>

<style lang="scss" scoped>
@import "../../caseCommon.scss";
.add-btn{
    margin-top:-64px;
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/carryOut/components/Acceptance.vue